export function autoCompleteDate() {
	// noop intentionally blank. All plugins loaded via WRM
}

export function autoCompleteDateWRM() {
	return [
		'wr!com.atlassian.confluence.plugins.confluence-inline-tasks:editor-autocomplete-date-conf-frontend',
	];
}
